import axios, { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class BillModel extends BaseModel {
    RouteName = "bill";
    protected AuthState: boolean = true;

    public async GetSearch(year: any,
        PlateNumber: any,
        Motaghazi: any,
        NationalCode: any,
        taxiCode?: any) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}/search?year=${year || ''}&PlateNumber=${PlateNumber || ''}&Motaghazi=${Motaghazi || ''}&NationalCode=${NationalCode || ''}&taxiCode=${taxiCode || ''}`);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }

            throw error.response?.data.message;
        }
    }
    public async GetAll() {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}`);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }

            throw error.response?.data.message;
        }
    }
    public async GetById(id:number|string) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}/${id}`);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }

            throw error.response?.data.message;
        }
    }
    public async addItem(data: any,id:number|string) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).post(`${this.RouteName}/${id}/add-item`, data);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }
            throw error.response?.data.message;
        }
    }
    public async SubmitData(data: any) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).post(`${this.RouteName}`, data);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }
            throw error.response?.data.message;
        }
    }
    public async EditData(id: number | string, data: any) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).put(`${this.RouteName}/${id}`, data);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }
            throw error.response?.data.message;
        }
    }
    public async Delete(id: number | string) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).delete(`${this.RouteName}/${id}`);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }
            throw error.response?.data.message;
        }
    }
    public async ChangeStatus(id: number | string) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).post(`${this.RouteName}/status/${id}`);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }
            throw error.response?.data?.message || error.message;
        }
    }

}
